class MenuButton extends HTMLElement {
    constructor() {
        super();
        this.addEventListener('focusout', this._onFocusOut);
        this.addEventListener('click', this._onClick);
    }

    /**
     * @param {boolean} [force]
     */
    _toggleMenu(force) {
        if (typeof force === 'boolean') {
            force = !force;
        }
        this.querySelector('.menu').toggleAttribute('hidden', force);
    }

    /**
     * @param {MouseEvent & {
     *     target: Element;
     * }} event
     */
    _onClick(event) {
        this._toggleMenu();
    }

    /**
     * @param {FocusEvent & {
     *     relatedTarget: Element;
     * }} event
     */
    _onFocusOut(event) {
        if (!this.contains(event.relatedTarget)) {
            this._toggleMenu(false);
        }
    }
}

customElements.define('menu-button', MenuButton);
export default MenuButton;
